import React, { Component } from 'react';
import TextField from '@material-ui/core/TextField';

export default class Note extends Component {
  render() {
    return (
      <div className="mobile-duties__textarea d-flex flex-column">
        <h2>یادداشت</h2>
        <div>فکر می‌کنید وظیفه شما نیاز به یک یادداشت دارد؟</div>
        <TextField
          className="mt-2"
          id="standard-textarea"
          label=""
          placeholder="یادداشت"
          multiline
        />
      </div>
    );
  }
}